import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import type { HighlightPropsInterface } from './types/highlight.types';

/**
 * @related ['Highlighter']
 * @since 8.28.0
 */
export const Highlight = forwardRef<HTMLElement, HighlightPropsInterface>(
  (props: HighlightPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;
    return (
      <mark
        ref={forwardedRef}
        data-c11n-component="Highlight"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'c11n_highlight', css(cssProp), className)}
        {...rest}
      >
        {children}
      </mark>
    );
  },
);

Highlight.displayName = 'Highlight';
